import { API_ORIGIN, apiUrl } from "./apiOrigin";
import React from 'react';
const {
  useState,
  useEffect
} = React;
const PREDEFINED_ROLES = ['Counter Staff', 'Manager', 'Storekeeper', 'Band Manager', 'Pre-Reg Pharmacist', 'Technician', 'Dispenser', 'Cleaning Staff', 'Pharmacist', 'Driver', 'AGT', 'Immunizations Patients'];
export default function SOPUpload() {
  const [files, setFiles] = useState([]);
  const [folders, setFolders] = useState([]);
  const [existingSops, setExistingSops] = useState([]);
  const [newFolderName, setNewFolderName] = useState('');
  const [showNewFolder, setShowNewFolder] = useState(false);
  const [staffList, setStaffList] = useState([]);
  const [gridData, setGridData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deploying, setDeploying] = useState(false);
  const [cascading, setCascading] = useState(false);
  const [cascadeTarget, setCascadeTarget] = useState('');
  const [message, setMessage] = useState('');
  const [activeTab, setActiveTab] = useState('upload');

  // Load initial data
  useEffect(() => {
    loadFolders();
    loadStaffList();
    loadExistingSops();
  }, []);
  const loadFolders = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const res = await fetch(apiUrl("/api/sop-folders?level=org"), {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      if (res.ok) {
        const data = await res.json();
        setFolders(data.folders || []);
      }
    } catch (e) {
      console.error('Failed to load folders:', e);
    }
  };
  const loadExistingSops = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const res = await fetch(apiUrl("/api/org-sops?limit=100"), {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      if (res.ok) {
        const data = await res.json();
        setExistingSops(data.sops || []);
      }
    } catch (e) {
      console.error('Failed to load existing SOPs:', e);
    }
  };
  const loadStaffList = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const res = await fetch(apiUrl("/api/staff-list"), {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      if (res.ok) {
        const data = await res.json();
        setStaffList(data.staff || []);
      }
    } catch (e) {
      console.error('Failed to load staff list:', e);
    }
  };
  const handleFileSelect = e => {
    const selectedFiles = Array.from(e.target.files);
    const newRows = selectedFiles.map(file => ({
      id: Date.now() + Math.random(),
      file,
      fileName: file.name,
      folder: '',
      roles: [],
      expiryDate: new Date(Date.now() + 2 * 365 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
      readingDue: new Date(Date.now() + 28 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
      assignToSop: '',
      staffSelection: {}
    }));
    setGridData([...gridData, ...newRows]);
  };
  const handleCreateFolder = async () => {
    if (!newFolderName.trim()) return;
    try {
      const token = localStorage.getItem('authToken');
      const res = await fetch(apiUrl("/api/sop-folders?level=org"), {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          folderName: newFolderName
        })
      });
      if (res.ok) {
        const data = await res.json();
        setFolders([...folders, data.folder]);
        setNewFolderName('');
        setShowNewFolder(false);
      }
    } catch (e) {
      console.error('Failed to create folder:', e);
    }
  };
  const updateGridRow = (id, field, value) => {
    setGridData(gridData.map(row => row.id === id ? {
      ...row,
      [field]: value
    } : row));
  };
  const updateStaffSelection = (id, staffId, checked) => {
    setGridData(gridData.map(row => {
      if (row.id === id) {
        const staffSelection = {
          ...row.staffSelection
        };
        if (checked) {
          staffSelection[staffId] = true;
        } else {
          delete staffSelection[staffId];
        }
        return {
          ...row,
          staffSelection
        };
      }
      return row;
    }));
  };
  const checkAllStaff = (id, checked) => {
    setGridData(gridData.map(row => {
      if (row.id === id) {
        const staffSelection = {};
        if (checked) {
          staffList.forEach(s => {
            staffSelection[s._id] = true;
          });
        }
        return {
          ...row,
          staffSelection
        };
      }
      return row;
    }));
  };
  const handleDeploy = async () => {
    setDeploying(true);
    setMessage('');
    try {
      const token = localStorage.getItem('authToken');
      const deploymentData = gridData.map(row => ({
        fileName: row.fileName,
        folder: row.folder,
        roles: row.roles,
        expiryDate: row.expiryDate,
        readingDue: row.readingDue,
        assignToSop: row.assignToSop,
        assignedStaff: Object.keys(row.staffSelection).filter(k => row.staffSelection[k])
      }));
      const res = await fetch(apiUrl("/api/org-sop-deploy"), {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          deployments: deploymentData
        })
      });
      if (res.ok) {
        setMessage('✅ Organization-level deployment successful!');
        setGridData([]);
        loadExistingSops();
      } else {
        setMessage('❌ Deployment failed');
      }
    } catch (e) {
      setMessage(`❌ Error: ${e.message}`);
    } finally {
      setDeploying(false);
    }
  };
  const handleCascade = async () => {
    if (!cascadeTarget) {
      setMessage('❌ Please select an SOP to cascade');
      return;
    }
    setCascading(true);
    setMessage('');
    try {
      const token = localStorage.getItem('authToken');
      const res = await fetch(apiUrl("/api/cascade-sop-to-branches"), {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          sopId: cascadeTarget
        })
      });
      if (res.ok) {
        const data = await res.json();
        setMessage(`✅ Cascaded to ${data.branchesUpdated} branches!`);
        setCascadeTarget('');
      } else {
        setMessage('❌ Cascade failed');
      }
    } catch (e) {
      setMessage(`❌ Error: ${e.message}`);
    } finally {
      setCascading(false);
    }
  };
  const removeRow = id => {
    setGridData(gridData.filter(row => row.id !== id));
  };
  return React.createElement('div', {
    style: {
      padding: '24px',
      maxWidth: '1400px'
    }
  }, React.createElement('h2', {
    style: {
      marginBottom: '24px',
      color: '#262626'
    }
  }, 'SOP Management - Organization Level'),
  // Tabs
  React.createElement('div', {
    style: {
      display: 'flex',
      gap: '12px',
      marginBottom: '24px',
      borderBottom: '2px solid #F0F0F0'
    }
  }, React.createElement('button', {
    onClick: () => setActiveTab('upload'),
    style: {
      padding: '12px 16px',
      background: activeTab === 'upload' ? '#2D5A3D' : '#fff',
      color: activeTab === 'upload' ? '#fff' : '#5D5D5D',
      border: 'none',
      borderBottom: activeTab === 'upload' ? '3px solid #2D5A3D' : 'none',
      cursor: 'pointer',
      fontWeight: '600',
      fontSize: '14px'
    }
  }, '📤 Upload SOPs'), React.createElement('button', {
    onClick: () => setActiveTab('cascade'),
    style: {
      padding: '12px 16px',
      background: activeTab === 'cascade' ? '#2D5A3D' : '#fff',
      color: activeTab === 'cascade' ? '#fff' : '#5D5D5D',
      border: 'none',
      borderBottom: activeTab === 'cascade' ? '3px solid #2D5A3D' : 'none',
      cursor: 'pointer',
      fontWeight: '600',
      fontSize: '14px'
    }
  }, '⬇️ Cascade to Branches')),
  // Message
  message && React.createElement('div', {
    style: {
      padding: '12px 16px',
      marginBottom: '16px',
      background: message.includes('✅') ? '#F6FFED' : '#FFF1F0',
      color: message.includes('✅') ? '#15803d' : '#CF1322',
      borderRadius: '6px',
      borderLeft: `4px solid ${message.includes('✅') ? '#15803d' : '#CF1322'}`
    }
  }, message),
  // UPLOAD TAB
  activeTab === 'upload' && React.createElement(React.Fragment, null, React.createElement('div', {
    style: {
      marginBottom: '24px'
    }
  }, React.createElement('label', {
    style: {
      display: 'inline-block',
      padding: '10px 16px',
      background: '#2D5A3D',
      color: '#fff',
      borderRadius: '6px',
      cursor: 'pointer',
      fontWeight: '500'
    }
  }, '📁 Select Files', React.createElement('input', {
    type: 'file',
    multiple: true,
    onChange: handleFileSelect,
    style: {
      display: 'none'
    },
    accept: '*/*'
  }))), gridData.length > 0 && React.createElement('div', {
    style: {
      overflowX: 'auto',
      border: '1px solid #F0F0F0',
      borderRadius: '8px',
      marginBottom: '24px'
    }
  }, React.createElement('table', {
    style: {
      width: '100%',
      borderCollapse: 'collapse',
      fontSize: '12px'
    }
  }, React.createElement('thead', null, React.createElement('tr', {
    style: {
      background: '#F5F5F5',
      borderBottom: '2px solid #F0F0F0'
    }
  }, React.createElement('th', {
    style: {
      padding: '12px',
      textAlign: 'left',
      fontWeight: '600'
    }
  }, 'File'), React.createElement('th', {
    style: {
      padding: '12px',
      textAlign: 'left',
      fontWeight: '600'
    }
  }, 'Folder'), React.createElement('th', {
    style: {
      padding: '12px',
      textAlign: 'left',
      fontWeight: '600'
    }
  }, 'Roles'), React.createElement('th', {
    style: {
      padding: '12px',
      textAlign: 'left',
      fontWeight: '600'
    }
  }, 'Assign to SOP'), React.createElement('th', {
    style: {
      padding: '12px',
      textAlign: 'left',
      fontWeight: '600'
    }
  }, 'Expiry'), React.createElement('th', {
    style: {
      padding: '12px',
      textAlign: 'left',
      fontWeight: '600'
    }
  }, 'Reading Due'), React.createElement('th', {
    style: {
      padding: '12px',
      textAlign: 'left',
      fontWeight: '600'
    }
  }, 'Staff'), React.createElement('th', {
    style: {
      padding: '12px',
      textAlign: 'center',
      fontWeight: '600'
    }
  }, 'Remove'))), React.createElement('tbody', null, gridData.map(row => React.createElement('tr', {
    key: row.id,
    style: {
      borderBottom: '1px solid #F5F5F5'
    }
  },
  // File name
  React.createElement('td', {
    style: {
      padding: '12px',
      maxWidth: '150px',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  }, row.fileName),
  // Folder
  React.createElement('td', {
    style: {
      padding: '12px'
    }
  }, React.createElement('div', {
    style: {
      display: 'flex',
      gap: '8px'
    }
  }, React.createElement('select', {
    value: row.folder,
    onChange: e => updateGridRow(row.id, 'folder', e.target.value),
    style: {
      padding: '6px 8px',
      border: '1px solid #D9D9D9',
      borderRadius: '4px',
      fontSize: '11px',
      flex: 1
    }
  }, React.createElement('option', {
    value: ''
  }, 'Select Folder'), folders.map(f => React.createElement('option', {
    key: f._id,
    value: f._id
  }, f.name))), React.createElement('button', {
    onClick: () => setShowNewFolder(!showNewFolder),
    style: {
      padding: '6px 8px',
      background: '#F5F5F5',
      border: '1px solid #D9D9D9',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '11px'
    }
  }, '+')), showNewFolder && React.createElement('div', {
    style: {
      marginTop: '8px',
      display: 'flex',
      gap: '4px'
    }
  }, React.createElement('input', {
    type: 'text',
    value: newFolderName,
    onChange: e => setNewFolderName(e.target.value),
    placeholder: 'New folder name',
    style: {
      padding: '6px 8px',
      border: '1px solid #D9D9D9',
      borderRadius: '4px',
      fontSize: '11px',
      flex: 1
    }
  }), React.createElement('button', {
    onClick: handleCreateFolder,
    style: {
      padding: '6px 10px',
      background: '#2D5A3D',
      color: '#fff',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '11px'
    }
  }, 'Create'))),
  // Roles
  React.createElement('td', {
    style: {
      padding: '12px'
    }
  }, React.createElement('div', {
    style: {
      border: '1px solid #D9D9D9',
      borderRadius: '4px',
      padding: '4px',
      maxHeight: '100px',
      overflowY: 'auto',
      fontSize: '11px'
    }
  }, PREDEFINED_ROLES.map(role => React.createElement('label', {
    key: role,
    style: {
      display: 'flex',
      alignItems: 'center',
      padding: '3px 6px',
      cursor: 'pointer'
    }
  }, React.createElement('input', {
    type: 'checkbox',
    checked: row.roles.includes(role),
    onChange: e => {
      const newRoles = e.target.checked ? [...row.roles, role] : row.roles.filter(r => r !== role);
      updateGridRow(row.id, 'roles', newRoles);
    },
    style: {
      marginRight: '4px',
      width: '14px',
      height: '14px'
    }
  }), role)))),
  // Assign to SOP
  React.createElement('td', {
    style: {
      padding: '12px'
    }
  }, React.createElement('select', {
    value: row.assignToSop,
    onChange: e => updateGridRow(row.id, 'assignToSop', e.target.value),
    style: {
      padding: '6px 8px',
      border: '1px solid #D9D9D9',
      borderRadius: '4px',
      fontSize: '11px',
      width: '100%'
    }
  }, React.createElement('option', {
    value: ''
  }, 'New SOP'), existingSops.map(sop => React.createElement('option', {
    key: sop._id,
    value: sop._id
  }, sop.title)))),
  // Expiry Date
  React.createElement('td', {
    style: {
      padding: '12px'
    }
  }, React.createElement('input', {
    type: 'date',
    value: row.expiryDate,
    onChange: e => updateGridRow(row.id, 'expiryDate', e.target.value),
    style: {
      padding: '6px 8px',
      border: '1px solid #D9D9D9',
      borderRadius: '4px',
      fontSize: '11px',
      width: '100%'
    }
  })),
  // Reading Due
  React.createElement('td', {
    style: {
      padding: '12px'
    }
  }, React.createElement('input', {
    type: 'date',
    value: row.readingDue,
    onChange: e => updateGridRow(row.id, 'readingDue', e.target.value),
    style: {
      padding: '6px 8px',
      border: '1px solid #D9D9D9',
      borderRadius: '4px',
      fontSize: '11px',
      width: '100%'
    }
  })),
  // Staff
  React.createElement('td', {
    style: {
      padding: '12px',
      fontSize: '11px'
    }
  }, React.createElement('div', {
    style: {
      border: '1px solid #D9D9D9',
      borderRadius: '4px',
      maxHeight: '80px',
      overflowY: 'auto',
      padding: '2px'
    }
  }, React.createElement('label', {
    style: {
      display: 'flex',
      alignItems: 'center',
      padding: '3px 6px',
      background: '#FAFAFA',
      fontWeight: '600',
      fontSize: '10px',
      borderBottom: '1px solid #F0F0F0'
    }
  }, React.createElement('input', {
    type: 'checkbox',
    checked: Object.values(row.staffSelection).every(v => v),
    onChange: e => checkAllStaff(row.id, e.target.checked),
    style: {
      marginRight: '4px',
      width: '12px',
      height: '12px'
    }
  }), 'All'), staffList.map(staff => React.createElement('label', {
    key: staff._id,
    style: {
      display: 'flex',
      alignItems: 'center',
      padding: '2px 6px',
      cursor: 'pointer'
    }
  }, React.createElement('input', {
    type: 'checkbox',
    checked: !!row.staffSelection[staff._id],
    onChange: e => updateStaffSelection(row.id, staff._id, e.target.checked),
    style: {
      marginRight: '4px',
      width: '12px',
      height: '12px'
    }
  }), staff.name)))),
  // Remove
  React.createElement('td', {
    style: {
      padding: '12px',
      textAlign: 'center'
    }
  }, React.createElement('button', {
    onClick: () => removeRow(row.id),
    style: {
      padding: '4px 8px',
      background: '#FFF1F0',
      color: '#CF1322',
      border: '1px solid #FFCCC7',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '11px'
    }
  }, '✕'))))))), gridData.length > 0 && React.createElement('button', {
    onClick: handleDeploy,
    disabled: deploying,
    style: {
      padding: '12px 24px',
      background: deploying ? '#8C8C8C' : '#2D5A3D',
      color: '#fff',
      border: 'none',
      borderRadius: '6px',
      cursor: deploying ? 'not-allowed' : 'pointer',
      fontWeight: '600',
      fontSize: '14px'
    }
  }, deploying ? '⏳ Deploying...' : '🚀 Deploy to Organization'), gridData.length === 0 && React.createElement('div', {
    style: {
      padding: '48px 24px',
      textAlign: 'center',
      color: '#5D5D5D'
    }
  }, '📋 Select files to begin uploading SOPs')),
  // CASCADE TAB
  activeTab === 'cascade' && React.createElement('div', {
    style: {
      padding: '24px',
      background: '#FAFAFA',
      borderRadius: '8px'
    }
  }, React.createElement('h3', {
    style: {
      marginBottom: '16px',
      color: '#262626'
    }
  }, 'Cascade Organization SOP to All Branches'), React.createElement('p', {
    style: {
      color: '#5D5D5D',
      marginBottom: '16px'
    }
  }, 'Select an organization-level SOP to cascade down to all branch locations. This will create/update the SOP template across all pharmacies.'), React.createElement('div', {
    style: {
      marginBottom: '24px'
    }
  }, React.createElement('label', {
    style: {
      display: 'block',
      marginBottom: '8px',
      fontWeight: '600',
      color: '#434343'
    }
  }, 'Select SOP to Cascade:'), React.createElement('select', {
    value: cascadeTarget,
    onChange: e => setCascadeTarget(e.target.value),
    style: {
      padding: '10px 12px',
      border: '1px solid #D9D9D9',
      borderRadius: '6px',
      fontSize: '14px',
      width: '100%',
      maxWidth: '400px'
    }
  }, React.createElement('option', {
    value: ''
  }, '-- Choose an SOP --'), existingSops.map(sop => React.createElement('option', {
    key: sop._id,
    value: sop._id
  }, sop.title)))), React.createElement('button', {
    onClick: handleCascade,
    disabled: cascading || !cascadeTarget,
    style: {
      padding: '12px 24px',
      background: cascading || !cascadeTarget ? '#8C8C8C' : '#2D5A3D',
      color: '#fff',
      border: 'none',
      borderRadius: '6px',
      cursor: cascading || !cascadeTarget ? 'not-allowed' : 'pointer',
      fontWeight: '600',
      fontSize: '14px'
    }
  }, cascading ? '⏳ Cascading...' : '⬇️ Cascade to All Branches')));
};
